import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback
} from 'react';

interface UnsavedChangesContext {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (value: boolean) => void;
  checkUnsavedChanges: () => boolean;
}

const UnsavedChangesCtx = createContext<UnsavedChangesContext | null>(null);

export function UnsavedChangesProvider({ children }: { children: ReactNode }) {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const checkUnsavedChanges = useCallback(() => {
    return hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  return (
    <UnsavedChangesCtx.Provider
      value={{ hasUnsavedChanges, setHasUnsavedChanges, checkUnsavedChanges }}
    >
      {children}
    </UnsavedChangesCtx.Provider>
  );
}

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesCtx);
  if (!context) {
    throw new Error(
      'useUnsavedChanges must be used within UnsavedChangesProvider'
    );
  }
  return context;
};
